import React from 'react';
import cn from 'classnames';
import styles from './default-regions.module.css';
import { LEFT_COL, RIGHT_COL } from './defaults';
var DefaultRegionItem = function DefaultRegionItem(_ref) {
  var region = _ref.region,
    selectedRegionValue = _ref.selectedRegionValue,
    onClick = _ref.onClick;
  var handleClick = function handleClick() {
    return onClick(region);
  };
  return React.createElement("div", {
    className: styles.defaultRegionItem
  }, selectedRegionValue === region.value ? React.createElement("span", {
    className: cn(styles.defaultRegionItemButton, styles.defaultRegionItemButtonMain)
  }, region.label) : React.createElement("button", {
    type: "button",
    className: styles.defaultRegionItemButton,
    onClick: handleClick
  }, region.label));
};
export var DefaultRegions = function DefaultRegions(_ref2) {
  var onRegionSelect = _ref2.onRegionSelect,
    selectedRegionValue = _ref2.selectedRegionValue;
  var handleDefaultRegionItemClick = function handleDefaultRegionItemClick(suggestion) {
    onRegionSelect(suggestion);
  };
  return React.createElement("div", {
    className: styles.defaultRegions
  }, React.createElement("div", {
    className: styles.defaultRegionsCol
  }, LEFT_COL.map(function (region) {
    return React.createElement(DefaultRegionItem, {
      key: region.value,
      region: region,
      onClick: handleDefaultRegionItemClick,
      selectedRegionValue: selectedRegionValue
    });
  })), React.createElement("div", {
    className: styles.defaultRegionsCol
  }, RIGHT_COL.map(function (region) {
    return React.createElement(DefaultRegionItem, {
      key: region.value,
      region: region,
      onClick: handleDefaultRegionItemClick,
      selectedRegionValue: selectedRegionValue
    });
  })));
};